export const heroNetworksText = {
  en: {
    small: "Business",
    main: "Networks",
  },
  vi: {
    small: "Mạng lưới",
    main: "Kết nối",
  },
};

export const quoteBusinessConsultingText = {
  en: {
    desc: `Whether you’re looking to improve workflow, reduce costs, or unlock new growth opportunities, our SME consulting service provides the strategies, tools, and guidance needed to turn business challenges into measurable success.`,
    cta: "Contact us now",
  },
  vi: {
    desc: `Dù bạn muốn tối ưu quy trình vận hành, giảm chi phí hay tìm kiếm cơ hội tăng trưởng mới, dịch vụ tư vấn doanh nghiệp SMEs của chúng tôi sẽ cung cấp chiến lược, công cụ và giải pháp thực tế để biến thách thức thành kết quả kinh doanh rõ ràng.`,
    cta: "Liên hệ ngay",
  },
};

// export const BusinessNetworksData = {
//   en: [
//     {
//       id: 1,
//       title: "BDI Business Development Network",
//       description:
//         "Connect with like-minded business owners, exchange insights, attend coaching sessions, and grow through a supportive business community.",
//       link: "https://www.facebook.com/groups/bdinetwork",
//       image: "/maria/fbnetwork/BDI.jpg",
//     },

//     {
//       id: 2,
//       title: "VBON Vietnamese Business Owner Network",
//       description:
//         "A network for Vietnamese business owners to connect, collaborate, and support each other in business growth and leadership.",
//       link: "https://www.facebook.com/groups/vietbizowner",
//       image: "/maria/fbnetwork/VBON.jpg",
//     },

//     {
//       id: 3,
//       title: "VBC Vietnamese Business Community",
//       description:
//         "Build meaningful relationships, share business experiences, and access valuable resources through a growing professional community.",
//       link: "https://www.facebook.com/groups/vbc.net/",
//       image: "/maria/fbnetwork/VBC.jpg",
//     },
//   ],

//   vi: [
//     {
//       id: 1,
//       title: "BDI Business Development Network",
//       description:
//         "Kết nối với các chủ doanh nghiệp cùng chí hướng, chia sẻ kinh nghiệm, tham gia coaching và phát triển trong một cộng đồng hỗ trợ tích cực.",
//       link: "https://www.facebook.com/groups/bdinetwork",
//     },

//     {
//       id: 2,
//       title: "VBON Vietnamese Business Owner Network",
//       description:
//         "Mạng lưới dành cho các chủ doanh nghiệp người Việt nhằm kết nối, hợp tác và cùng nhau phát triển kinh doanh bền vững.",
//       link: "https://www.facebook.com/groups/vietbizowner",
//     },

//     {
//       id: 3,
//       title: "VBC Vietnamese Business Community",
//       description:
//         "Xây dựng các mối quan hệ giá trị, chia sẻ kinh nghiệm kinh doanh và tiếp cận nguồn tài nguyên hữu ích từ cộng đồng chuyên nghiệp.",
//       link: "https://www.facebook.com/groups/vbc.net/",
//     },
//   ],
// };

export const BusinessNetworksData = {
  en: [
    {
      id: 1,
      code: "BDI",
      title: "BDI Business Network",
      subtitle: "Business Development & Investment Network",
      description:
        "A premium network connecting business owners, investors and professionals for high-value collaboration, deal flow and growth opportunities across NZ & Australia.",
      members: "200+",
      membersLabel: "Members",
      events: "Monthly",
      eventsLabel: "Meetings",
      region: "NZ & Australia",
      regionLabel: "Region",
      color: "#1F436B",
      link: "https://www.facebook.com/groups/bdinetwork",
      image: "/maria/fbnetwork/BDI.jpg",
    },

    {
      id: 2,
      code: "VBON",
      title: "VBON Business Owners",
      subtitle: "Vietnamese Business Owners Network",
      description:
        "The leading network for Vietnamese-background business owners in NZ & Australia. Peer learning, community support and business connections in a trusted cultural environment.",
      members: "500+",
      membersLabel: "Members",
      events: "Bi-monthly",
      eventsLabel: "Meetings",
      region: "NZ · AU · Vietnam",
      regionLabel: "Region",
      color: "#C82128",
      link: "https://www.facebook.com/groups/vietbizowner",
      image: "/maria/fbnetwork/VBON.jpg",
    },

    {
      id: 3,
      code: "VBC",
      title: "VBC Business Coaches",
      subtitle: "Vietnam Business Coaches Community",
      description:
        "A professional community for certified business coaches. Continuous learning, peer mentoring and best practice sharing to elevate coaching standards across the region.",
      members: "150+",
      membersLabel: "Members",
      events: "Quarterly",
      eventsLabel: "Meetings",
      region: "ANZ & Vietnam",
      regionLabel: "Region",
      color: "#1F6A4F",
      link: "https://www.facebook.com/groups/vbc.net/",
      image: "/maria/fbnetwork/VBC.jpg",
    },
  ],

  vi: [
    {
      id: 1,
      code: "BDI",
      title: "Mạng lưới Doanh nghiệp BDI",
      subtitle: "Phát triển Kinh doanh & Đầu tư",
      description:
        "Mạng lưới cao cấp kết nối chủ doanh nghiệp, nhà đầu tư và chuyên gia nhằm tạo ra cơ hội hợp tác giá trị, giao thương và tăng trưởng tại New Zealand và Úc.",
      members: "200+",
      membersLabel: "Thành viên",
      events: "Hàng tháng",
      eventsLabel: "Sự kiện",
      region: "NZ & Úc",
      regionLabel: "Khu vực",
      color: "#1F436B",
      link: "https://www.facebook.com/groups/bdinetwork",
      image: "/maria/fbnetwork/BDI.jpg",
    },

    {
      id: 2,
      code: "VBON",
      title: "Mạng lưới Chủ Doanh nghiệp VBON",
      subtitle: "Vietnamese Business Owners Network",
      description:
        "Cộng đồng hàng đầu dành cho các chủ doanh nghiệp gốc Việt tại New Zealand và Úc. Nơi học hỏi, hỗ trợ lẫn nhau và xây dựng các mối quan hệ kinh doanh trong môi trường tin cậy và cùng văn hóa.",
      members: "500+",
      membersLabel: "Thành viên",
      events: "2 tháng/lần",
      eventsLabel: "Sự kiện",
      region: "NZ · Úc · Việt Nam",
      regionLabel: "Khu vực",
      color: "#C82128",
      link: "https://www.facebook.com/groups/vietbizowner",
      image: "/maria/fbnetwork/VBON.jpg",
    },

    {
      id: 3,
      code: "VBC",
      title: "Cộng đồng Huấn luyện Doanh nghiệp VBC",
      subtitle: "Vietnam Business Coaches Community",
      description:
        "Cộng đồng chuyên nghiệp dành cho các Business Coach. Tập trung vào học tập liên tục, cố vấn đồng cấp và chia sẻ thực tiễn tốt nhất nhằm nâng cao chất lượng tư vấn doanh nghiệp trong khu vực.",
      members: "150+",
      membersLabel: "Thành viên",
      events: "Hàng quý",
      eventsLabel: "Sự kiện",
      region: "ANZ & Việt Nam",
      regionLabel: "Khu vực",
      color: "#1F6A4F",
      link: "https://www.facebook.com/groups/vbc.net/",
      image: "/maria/fbnetwork/VBC.jpg",
    },
  ],
};
